import { render, staticRenderFns } from "./materials-dialog.vue?vue&type=template&id=7729e292"
import script from "./materials-dialog.vue?vue&type=script&lang=js"
export * from "./materials-dialog.vue?vue&type=script&lang=js"
import style0 from "./materials-dialog.vue?vue&type=style&index=0&id=7729e292&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports